(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!window.empathColorDisclosureReady) {
    window.empathColorDisclosureReady = true;

    document.addEventListener('click', (event) => {
      const sizeGuide = event.target.closest('[data-empath-size-guide]');
      if (sizeGuide) {
        const label = sizeGuide.textContent.trim().toLocaleLowerCase();
        const target = [...document.querySelectorAll('hdt-tab button')].find((button) => {
          return button.textContent.trim().toLocaleLowerCase() === label;
        });

        if (target) {
          target.click();
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      const toggle = event.target.closest('[data-empath-color-toggle]');
      if (!toggle) return;

      const options = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!options) return;

      const willExpand = options.classList.contains('is-collapsed');
      options.classList.toggle('is-collapsed', !willExpand);
      toggle.setAttribute('aria-expanded', String(willExpand));
      toggle.querySelector('[data-show-colors]').hidden = willExpand;
      toggle.querySelector('[data-hide-colors]').hidden = !willExpand;
    });

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

      const options = input.closest('.empath-color-options');
      if (!options) return;

      options.querySelectorAll('.empath-color-option--selected').forEach((option) => {
        option.classList.remove('empath-color-option--selected');
      });

      const label = options.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (label) {
        const option = label.closest('.hdt-swatch__item') || label;
        option.classList.add('empath-color-option--selected');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
